import React from 'react';
import * as yup from 'yup';
import { each } from 'lodash';
import { useFormik } from 'formik';
import { Link, useLocation } from 'react-router-dom';

import FormInput from 'partial/form/FormInput';
import Button from 'partial/components/Button';
import FormPassword from 'partial/form/FormPassword';
import Form, { ErrorLabel } from 'partial/form/Form';
import { useCreateModal } from 'partial/components/Modal';

import { useLogin } from '../hooks';
import ForgotPasswordModal from '../modals/ForgotPasswordModal';

const initialValues = (location) => ({
  email_address: location?.state?.email_address || '',
  password: '',
});

const validationSchema = yup.object().shape({
  email_address: yup.string().email('Invalid').required('Required'),
  password: yup.string().required('Required'),
});

function LoginForm() {
  const location = useLocation();

  const [isLoading, login] = useLogin();
  const [validateOnChange, setValidateOnChange] = React.useState(false);

  const createModal = useCreateModal();
  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    initialValues: initialValues(location),
    validationSchema,
    onSubmit: async (form, { setFieldError }) => {
      login(
        form,
        () => {}, // onSuccess
        (err) => {
          each(err, (v, k) => {
            setFieldError(k, v);
          });
        }
      );
    },
    validateOnChange,
  });

  const handleForgotPassword = () => {
    createModal({
      content: (close) => <ForgotPasswordModal onClose={close} />,
    });
  };
  return (
    <Form
      onSubmit={handleSubmit}
      error={errors}
      noValidate
      className="space-y-3"
    >
      <div>
        <FormInput
          name="email_address"
          onSetFieldValue={setFieldValue}
          value={values.email_address}
          label="Email Address"
          placeholder="name@domain.com"
          error={errors.email_address}
        />
        <ErrorLabel name="email_address" />
      </div>
      <div>
        <FormPassword
          name="password"
          label="Password"
          placeholder="Enter password"
          onSetFieldValue={setFieldValue}
          value={values.password}
          error={errors.password}
          noAutoFill
        />
        <ErrorLabel name="password" />
      </div>
      <Button
        primary
        type="submit"
        className="w-full"
        isLoading={isLoading}
        onClick={() => setValidateOnChange(true)}
      >
        Login
      </Button>
      <div>
        <div className="mt-6 text-center">
          <button
            type="button"
            className="font-normal border-b border-dashed border-gray-400 text-gray-600"
            onClick={handleForgotPassword}
          >
            Forgot Password
          </button>
        </div>
        <div className="text-center space-x-1 mt-6 font-medium">
          <span>Don&apos;t have an account yet?</span>
          <Link className="inline-block underline" to="/signup">
            Sign up now
          </Link>
        </div>
      </div>
    </Form>
  );
}

LoginForm.propTypes = {};

export default LoginForm;
